/*
 * Actions types
 */
export enum HistoricoType {
  HISTORICO_RESQUEST = '@historico/HISTORICO_RESQUEST',
  HISTORICO_SUCCESS = '@historico/HISTORICO_SUCCESS',
  HISTORICO_FAILURE = '@historico/HISTORICO_FAILURE',
  DETALHE_HISTORICO_RESQUEST = '@historico/DETALHE_HISTORICO_RESQUEST',
  DETALHE_HISTORICO_SUCCESS = '@historico/DETALHE_HISTORICO_SUCCESS',
  DETALHE_HISTORICO_FAILURE = '@historico/DETALHE_HISTORICO_FAILURE',
  RESET_PAGE = '@historico/RESET_PAGE',
  CLEAN_MODAL = '@historico/CLEAN_MODAL',
}

/*
 * State Type
 */
export interface HistoricoState {
  readonly data: any;
  readonly detalhe: any;
  readonly resetPage: any;
  readonly cleanModal: number;
  readonly loading: boolean;
  readonly error: boolean;
}
